import { CalculateTaxResponse } from './src/service-plugins-types.js';
import { CalculateTaxEnvelope } from './src/interfaces-billing-v1-tax-calculation-provider.public.js';

export * from './src/service-plugins-types';
export { CalculateTaxEnvelope };

/**
 * Calculates tax for the provided line items.
 *
 * Tax is calculated for each line item based on the tax region
 * in `lineItems.taxRegionId` and the tax group in `lineItems.taxGroupId`.
 *
 * The breakdown of calculated tax returned, includes:
 * + `taxSummary`: The overall total tax calculated.
 * + `lineItemTaxDetails.taxBreakdown`: The tax calculated for each line item in each jurisdiction.
 * + `lineItemTaxDetails.taxSummary`: The total tax calculated for each line item.
 */
export declare function calculateTax(
  payload: CalculateTaxEnvelope
): CalculateTaxResponse | Promise<CalculateTaxResponse>;
